import { render, staticRenderFns } from "./IvsInformation.vue?vue&type=template&id=3db8e8fb&scoped=true&"
import script from "./IvsInformation.vue?vue&type=script&lang=js&"
export * from "./IvsInformation.vue?vue&type=script&lang=js&"
import style0 from "./IvsInformation.vue?vue&type=style&index=0&id=3db8e8fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db8e8fb",
  null
  
)

export default component.exports